export default __webpack_public_path__ + "static/media/hyperlink-icon.b706dced.svg";